import genericRule from '../../namespace/relation/doingCreate_namespace_relation';

export default {
    ...genericRule,
    excludedNamespaceRelations: [],
    namespace: 'application',
    relation: 'sharedFilter'
};
